import React from 'react'

export const BeFiltersApiContext = React.createContext({ apiContext: null })
